import type { ReviewConflict } from "@/api/db/people";
import { SourceBadge } from "@/components/people/source-badge";
import { format } from "@/lib/format";
import { cn } from "@/lib/utils";

type Source = ReviewConflict["source_a"];

const MONO_FIELDS = new Set(["cpf", "phone", "address", "birth_date", "cep"]);

function ConflictValue({
	field,
	value,
	source,
	valueSlot,
	sourceSlot,
}: {
	field: string;
	value: string | null;
	source: Source;
	valueSlot?: string;
	sourceSlot?: string;
}) {
	const mono = MONO_FIELDS.has(field);

	return (
		<span className="inline-flex flex-wrap items-center gap-1.5">
			<span data-slot={valueSlot} className={cn("text-sm text-foreground", mono && "font-mono")}>
				{format.orDash(format.conflictValue(field, value))}
			</span>

			{!!source && (
				<span data-slot={sourceSlot} data-source={source}>
					<SourceBadge source={source} />
				</span>
			)}
		</span>
	);
}

export function ConflictRow({
	field,
	valueA,
	sourceA,
	valueB,
	sourceB,
	detail,
	slots,
}: {
	field: string;
	valueA: string | null;
	sourceA: Source;
	valueB: string | null;
	sourceB: Source;
	detail: string | null;
	slots?: boolean;
}) {
	return (
		<>
			<div className="grid gap-2 sm:grid-cols-2">
				<ConflictValue
					field={field}
					value={valueA}
					source={sourceA}
					valueSlot={slots ? "value-a" : undefined}
					sourceSlot={slots ? "source-a" : undefined}
				/>
				<ConflictValue
					field={field}
					value={valueB}
					source={sourceB}
					valueSlot={slots ? "value-b" : undefined}
					sourceSlot={slots ? "source-b" : undefined}
				/>
			</div>

			{!!detail && (
				<p data-slot={slots ? "detail" : undefined} className="text-xs text-muted-foreground">
					{detail}
				</p>
			)}
		</>
	);
}
